export const DEFAULT_IMAGE = "../../../images/logo.png";
